import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { validateStatusCode } from "common/helpers/HTTP";

import { isBlobUrl } from "../utils";

interface UseFileProxyParams {
  accountId: string;
  url: string;
}

async function getBlobRequest(
  workspaceId: string,
  accountId: string,
  url: string,
) {
  const encodedUrl = encodeURIComponent(url);
  const token = localStorage.getItem("auth");

  const apiUrl = isBlobUrl(url)
    ? url
    : `${import.meta.env.VITE_API_URL}workspaces/${workspaceId}/accounts/${accountId}/file?url=${encodedUrl}`;

  return fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(validateStatusCode)
    .then(async (response) => {
      const blob = await response.blob();
      return { blob, url: URL.createObjectURL(blob) };
    });
}

export default function useMessageAttachment({
  accountId,
  url,
}: UseFileProxyParams) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const queryKey = [workspaceId, accountId, "attachmentData", url];

  const {
    data: attachmentData,
    isLoading: isLoadingAttachmentData,
    error: attachmentDataError,
  } = useQuery({
    queryKey,
    queryFn: () => getBlobRequest(workspaceId, accountId, url),
    enabled: !!accountId,
  });

  return {
    attachmentData,
    isLoadingAttachmentData,
    attachmentDataError,
  };
}
